import type { certificationInfoState } from './type'
import type { QualData, FinanceData, InvoiceTypeOption } from '@/service/types/certification'
import { reqQualifications, reqFinanceInfo } from '@/service/apis'
import { defineStore } from 'pinia'
import useDeveloperStore from '@/stores/developerStore'

const useCertificationInfoStore = defineStore('certificationInfo', {
  state(): certificationInfoState {
    return {
      companyQualifications: {
        companyName: '', // 企业名称
        busslicenseAddInfo: '', // （国内版：注册地址详细地址；国际版：公司所在地）
        busslicenseFileUrl: '', // （国内版：营业执照文件url；国际版：公司注册信息图片url）
        busslicenseNumber: '', // （国内版：营业执照注册号；国际版：营业执照（香港地区为商业登记号））
        homepageUrl: '', // 官网地址
        qualLegalName: '', // 法人代表姓名
        invoiceType: '', // 发票类型
        busslicenseAddress: '', // 注册地址省市
        qualMobile: '', // 法人代表联系人电话
        qualEmail: '', // 法人代表联系邮箱
        certificateEffectStartTime: '', // 证件开始有效期
        certificateEffectEndTime: '', // 证件结束有效期
        busslicenseFileIds: '' // 营业执照文件id
      },
      financialInfo: {
        developerId: '',
        accountName: '',
        accountBank: '',
        bankAddress: '',
        bankBranch: '',
        bankCardNumber: '',
        financeMan: '',
        financeEmail: '',
        financePhone: '',
        settleAddress: '',
        settleAddInfo: '',
        payeeAddress: '',
        payeeName: '',
        payeeNation: '',
        receiveBankInTransitAccount: '',
        receiveBankNation: '',
        receiveBankSwiftCode: '',
        transitBankAddress: '',
        transitBankName: '',
        transitBankNation: '',
        transitBankSwiftCode: ''
      },
      invoiceTypeArr: []
    }
  },
  actions: {
    /**
     * 获取资质信息数据
     */
    async getCertificationInfoData() {
      const developerStore = useDeveloperStore()
      const [
        {
          data: { qualData, invoiceTypeArr }
        },
        {
          data: { financeData }
        }
      ] = await Promise.all([reqQualifications({}), reqFinanceInfo({})])

      this.setCompanyQualifications(qualData)
      this.setInvoiceTypeArr(invoiceTypeArr)
      this.setFinancialInfo(financeData)
      developerStore.setDeveloperAvatar()
      return true
    },
    /**
     * 设置企业资质信息
     */
    setCompanyQualifications(qualData: QualData) {
      this.companyQualifications = {
        companyName: qualData.companyName,
        busslicenseAddInfo: qualData.busslicenseAddInfo,
        busslicenseFileUrl: qualData.busslicenseFileUrl,
        busslicenseNumber: qualData.busslicenseNumber,
        homepageUrl: qualData.homepageUrl,
        qualLegalName: qualData.qualLegalName,
        invoiceType: qualData.invoiceType,
        busslicenseAddress: qualData.busslicenseAddress,
        qualMobile: qualData.qualMobile,
        qualEmail: qualData.qualEmail,
        certificateEffectStartTime: qualData.certificateEffectStartTime,
        certificateEffectEndTime: qualData.certificateEffectEndTime,
        busslicenseFileIds: qualData.busslicenseFileIds
      }
    },
    /**
     * 设置发票类型
     */
    setInvoiceTypeArr(invoiceTypeArr: Array<InvoiceTypeOption>) {
      this.invoiceTypeArr = invoiceTypeArr
    },
    /**
     * 设置财务信息
     */
    setFinancialInfo(financeData: FinanceData) {
      this.financialInfo = financeData
    },
    /**
     * 清空企业资质信息
     */
    clearCompanyQualifications() {
      Object.keys(this.companyQualifications).forEach((key) => {
        this.companyQualifications[key] = ''
      })
    },
    /**
     * 清空财务信息
     */
    clearFinancialInfo() {
      Object.keys(this.financialInfo).forEach((key) => {
        this.financialInfo[key] = ''
      })
    },
    /**
     * 清空发票类型
     */
    clearInvoiceTypeArr() {
      this.invoiceTypeArr = []
    },
    clearCertificationInfoData() {
      this.clearCompanyQualifications()
      this.clearFinancialInfo()
      this.clearInvoiceTypeArr()
    }
  },
  persist: true
})

export default useCertificationInfoStore
